import { Box, Breadcrumbs, Link, Typography } from "@material-ui/core";
import { useEffect, useRef } from "react";
import type { FC } from "react";
import { Helmet } from "react-helmet";
import { Link as RouterLink, useParams, useSearchParams } from "react-router-dom";

import { useScopedHref } from "@/hooks";
import { useT } from "@/i18n";
import { DisciplineForm } from "src/components/dashboard/disciplines";

const DisciplineCreate: FC = () => {
  const t = useT();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const section = searchParams.get("section");
  const scopedHref = useScopedHref();
  const refDisplay = useRef<HTMLDivElement>(null);
  const handleScroll = () => {
    setTimeout(() => {
      if (refDisplay && refDisplay.current) {
        refDisplay.current.scrollIntoView({
          block: "start",
        });
      }
    }, 0);
  };

  useEffect(() => {
    handleScroll();
  }, []);

  return (
    <>
      <Helmet>
        <title>Dashboard: Discipline Create</title>
      </Helmet>
      <Box ref={refDisplay} />
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "calc(100% - 110px)",
          border: "1px solid rgb(237, 241, 246)",
          px: { sm: "24px", xs: "10px" },
          my: 4,
          pt: 2,
          borderRadius: "8px",
        }}
      >
        <Breadcrumbs aria-label="breadcrumb" separator={"/"}>
          <Link color="textPrimary" component={RouterLink} to={scopedHref("/")} variant="subtitle2">
            {t("Dashboard")}
          </Link>
          <Link
            color="textPrimary"
            component={RouterLink}
            to={
              section
                ? scopedHref("/disciplines")
                : scopedHref(
                    `/platforms/settings/current?platformActiveTab=disciplines&platformTab=settings`
                  )
            }
            variant="subtitle2"
          >
            {t("Disciplines")}
          </Link>
          <Typography color="textSecondary" variant="subtitle2">
            {id ? t("Edit") : t("Add new Discipline")}
          </Typography>
        </Breadcrumbs>
        <Box>
          <DisciplineForm />
        </Box>
      </Box>
    </>
  );
};

export default DisciplineCreate;
